/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Finnish
export default {
  'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Tyhjennä valinta',
  'paginated-picker.async-select.menu-list.error-message.error-message': 'Tietoja ei voitu noutaa',
  'paginated-picker.async-select.menu-list.error-message.retry-message': 'Yritä uudelleen napsauttamalla',
  'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Ladataan...',
  'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Näytä lisää',
  'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
  'paginated-picker.async-select.select.no-options-message.no-options-message': 'Ei hakutuloksia',
  'paginated-picker.async-select.select.option.error-message': 'Tietoja ei voitu noutaa',
  'paginated-picker.async-select.select.option.retry-message': 'Yritä uudelleen napsauttamalla',
  'paginated-picker.async-select.select.search-placeholder': 'Hae',
  'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Näytä koko luettelo'
};